import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  const getMessage = (e: unknown): string => {
    if (typeof e === "string") return e;
    if (e && typeof e === "object") {
      const maybe = e as { statusText?: unknown; message?: unknown };
      if (typeof maybe.statusText === "string") return maybe.statusText;
      if (typeof maybe.message === "string") return maybe.message;
    }
    return "Unknown error";
  };

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{getMessage(error)}</i>
      </p>
    </div>
  );
}
